import React from "react";
import { Link } from "react-router-dom";
// import BannerBG from "../../assets/images/banner-img-03.jpg";
// import Banner404 from "../../assets/images/error-404-img-03.png";
// import BeforeBGImage from "../../assets/images/error-404-img-01.png";
// import AfterBGImage from "../../assets/images/error-404-img-02.png";

import Image404 from "./../../assets/images/image_404.png";
import ImageErrorBg from "./../../assets/images/image_error_bg.jpg";

const PageNotFound: React.FC = () => {
	const ErrorTitle = "We are Sorry...";
	const ErrorMsg = "<p>Sorry, the page you are looking for does not exist. <br /> The link you followed may be broken, or the page may have been removed.</p>";

	return (
		<section className="section unauthorized__section" style={{ backgroundImage: `url(${ImageErrorBg})` }}>
			<img src={Image404} alt="404" className="404 Error" />
			<h3 className="errorTitle">{ErrorTitle}</h3>
			<div dangerouslySetInnerHTML={{ __html: ErrorMsg }}></div>
			<Link to="/" className="ant-btn ant-btn-error">
				Back to Home
			</Link>
		</section>
		// <section className="innerFullBanner error404 pv-64" style={{ backgroundImage: `url(${BannerBG})` }}>
		// 	<div className="item_wrap">
		// 		<span className="beforeImg" style={{ backgroundImage: `url(${BeforeBGImage})` }}></span>
		// 		<div className="container">
		// 			<div className="banner_content">
		// 				<div className="error404_wrap">
		// 					<img src={Banner404} alt="" />
		// 					<div className="content">
		// 						<p>The page you are looking for does not exist. How you got here is a mystery. But you can click the button below to go back to the homepage.</p>
		// 						<Link to="/" className="btn btn_secondary radius50">
		// 							Back to Home
		// 						</Link>
		// 					</div>
		// 				</div>
		// 			</div>
		// 		</div>
		// 		<span className="afterImg" style={{ backgroundImage: `url(${AfterBGImage})` }}></span>
		// 	</div>
		// </section>
	);
};

export default PageNotFound;
